<template>
	<div>
		<div class="row preFilterBlk">
			<div class="col-md-10 d-flex">
				<div class="col-md-3">
					<ReInputSearchDrop 
						name="fio"
						placeholder="ФИО"
						strType="client"
						v-model="client_fio"
						:objApiMethod="{obj:'client' ,flt:{fio:''}}"
						strApiMethodKey="fio"
						v-on:change="OnFioSearch"
					/>
				</div>
				<div v-if="false" class="col-md-3">
					<ReInputSearchDrop 
						name="contacts"
						placeholder="Контакты старый"
						strType="client"
						v-model="client_contacts"

						:objApiMethod="{obj:'client' ,flt:{contact:''}}"
						strApiMethodKey="contact"
						strApiMethod="GET"
						
						v-on:change="OnContactSearch"
						v-on:typedText="OnContactTypedText"
					/>
				</div>
				<div class="col-md-3">
					<ReInputSearchDrop 
						name="contacts"
						placeholder="Контакты"
						strType="client"
						v-model="client_contacts"
						:objApiMethod="{obj:'client' ,flt:{contact_value:''}}"
						strApiMethodKey="contact_value"
						strApiMethod="GET_CLIENTFIND"
						v-on:change="OnContactSearch"
						v-on:typedText="OnContactTypedText"
					/>
				</div>
				<div class="filter-tag-row"><ReFilterBtn v-model="bShowFilter" :bShowOptsCount="false"/><span class="ml-3 el-tag el-tag--small el-tag el-tag--plain el-tag--primary">Клиентов найдено: {{this.masClients_total}}</span></div>
			</div>
			<div class="pl-4">
				<button class="btn btn-simple btn-primary" @click="AddClient()">Добавить клиента</button>
			</div>
		</div>
		<div class="row"
			v-loading.fullscreen.lock="$GVO.fullscreenLoading"
			element-loading-text="Загрузка данных..."
			element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)"	
		>
			<div class="col-lg-6 mt-2" v-show="bShowFilter">
				<ReFilter :masAllFilterParams="masAllFilterParams" 
				v-model="objGetParams" 
				v-on:filterapply="OnFilterApply"
				name="clients"/>
			</div>
			<div class="col-12 mt-2" v-if="masClients.length>0">
				<ReSearchCardClient v-for="objClient in masClients" :key="objClient.id" :objClient="objClient"/>
				<Pagination :class="[{'': parseInt(masClients_total) > 0}, {'d-none': parseInt(masClients_total) < 1}]"
					:type="'info'" 
					:total="parseInt(masClients_total)" 
					:perPage="parseInt(10)" 
					:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
					:pClick="pClick">
				</Pagination>				
			</div>
			<div class="col-12" v-else><h3>Ничего не найдено</h3></div>
		</div>
	</div>
</template>

<script>

import {eventEmitter} from "src/plugins/globalComponents.js";
import ReSearchCardClient from 'src/our_components/ReSearchCardClient';
import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
import Pagination from 'src/our_components/RePagination';
import ReInputSearchDrop from 'src/our_components/ReInputSearchDrop.vue';
import { Select, Option } from 'element-ui';

export default {
	name: 'clients-page',
	components:{
		ReSearchCardClient,
		ReFilter,
		ReFilterBtn,
		Pagination,
		ReInputSearchDrop,
		[Option.name]: Option,
		[Select.name]: Select,
	},
	data() {
		return {
			masClients: [],
			masClients_total:0,
			bShowFilter: false,
			objGetParams: {},
			masAllFilterParams: this.currentFilterConfig(),
			client_fio: {inputText: '', selectedVal:''},
			client_contacts: {inputText: '', selectedVal:''},
			selServVal: '',
			selServOpts:[
				{value:'1',label:'uno'},
				{value:'2',label:'duo'},
			],
			strContactTypedText: '',
			//fullscreenLoading: false,
		};
	},
	methods: {
		currentFilterConfig(){
			//return require("src/conf/clientsFilterConfig.js").super_config;

			this.$GVO.ApiCall('GET_FILTER',{obj:'client'})
				.then((objApi) => {
					//console.log(objApi);
					if(objApi.success){
						this.masAllFilterParams = objApi.config;
						eventEmitter.$emit('OnFilterConfigLoad', this.masAllFilterParams);
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		getClients(){
			this.objGetParams = this.$GVO.GetAllGet();
			let filter = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				//console.log('getClients',this.objGetParams);
				filter = this.objGetParams;
			}
			//console.log('getClients',filter);
			this.$GVO.ApiCall('GET',{obj:'client' ,flt:{...{list:true,'addVirtWatsapp':1}, ...filter} })
			.then((objApi) => { 
				this.masClients
				this.masClients_total = 0;
				if(objApi.success === true){ //console.log(objApi);
					this.masClients = objApi.data;
					if(objApi.total!=undefined) { this.masClients_total=objApi.total; }
				}else{
					this.masClients = [];
					//this.openFullScreen1();
				}
			}).catch((errorObjApi) => {console.error(errorObjApi); this.masClients = [];});
		},
		
		OnFilterApply(data){
			// console.log('this.$GVO.my_profile.code ',this.$GVO.my_profile.code);
			//this.objGetParams = data;
			
			//console.log('OnFilterApply',this.objGetParams);
			for (const key in this.objGetParams) {
				if (Object.hasOwnProperty.call(this.objGetParams, key)) {
					if(this.objGetParams[key] == '') delete this.objGetParams[key];
					if(key == 'rb_service' && this.objGetParams[key] == '0') delete this.objGetParams[key];
				}
			}
			

			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			//console.log('OnFilterApply',strItogGetParams,this.objGetParams);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			eventEmitter.$emit('OnFilterApply', this.objGetParams);
			// console.log('OnFilterApply',data);
			// console.log('this.masClients ',this.masClients.length);
			// console.log('this.masClients_total ',this.masClients_total);
			this.getClients();
			//this.openFullScreen1();
		},
		pClick(e){
			this.objGetParams['p'] = parseInt(e);
			this.OnFilterApply();
		},
		OnFioSearch(data){
			/*
			this.objGetParams['id'] = data.selectedVal;
			this.OnFilterApply();
			*/
			this.$router.push({path:'/data/clients/id/'+data.selectedVal});
		},
		OnContactSearch(data){
			//console.log(this.strContactTypedText,data.selectedVal);
			this.$GVO.ApiCall('ADD_CLIENT_OWNER',{obj:'client',flt:{'client_id':data.selectedVal,'client_contact_value':this.strContactTypedText},iData:{'agent_code':this.$GVO.my_profile.code}})
				.then((objApi) => {
					//console.log(objApi);
					if(objApi.success){
						
					}
					/*
					this.objGetParams['id'] = data.selectedVal;
					this.OnFilterApply();
					*/
					location.href = '/data/clients/id/'+data.selectedVal;
				})
				.catch(errorObjApi => {console.error(errorObjApi); this.objGetParams['id'] = data.selectedVal; this.OnFilterApply(); });
		},
		OnContactTypedText(data){
			this.strContactTypedText = data;
			// console.log('strContactTypedText',this.strContactTypedText);
		},
		ResetDopFilter(){
			this.client_fio = {inputText: '', selectedVal:''};
			this.client_contacts = {inputText: '', selectedVal:''};
			delete this.objGetParams['id'];
			this.selServVal = '';
			this.OnFilterApply();
		},
		AddClient(){
			this.$router.push({path: '/data/clients/add'});
		},
		openFullScreen1() {
			this.fullscreenLoading = true;
			setTimeout(() => {
			this.fullscreenLoading = false;
			}, 3000);
		},
	},
	created() {
		eventEmitter.$on('ResetFilter', this.ResetDopFilter);
		//this.getClients();		
	},
	beforeDestroy() {
		// Отписываемся от события
		eventEmitter.$off('ResetFilter', this.ResetDopFilter);
	},
};
</script>
<style scoped>
	
	.titleBlk{
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		margin-bottom: 15px;
	}

	.titleBlk h3{margin-bottom: 0px;}

	.titleBlk .avatarBlk{width:215px;}

	.titleBlk .left_part, .titleBlk .right_part{
		width: 100%;
		display: flex;
		flex-flow: row nowrap;
	}
	.titleBlk .right_part{justify-content: space-between;}
	.titleBlk .left_part > *, .titleBlk .right_part > *{display: inline-block; vertical-align: top;}
	.titleBlk .orgBlk{width:285px;}

	.preFilterBlk{align-items: baseline; margin-top:20px;}
	.filter-tag-row {
		display: flex;
		flex-flow: row nowrap;
		align-items: center;
	}

	@media (max-width: 1100px){
		.titleBlk{display: none;}
	}
	@media (max-width: 576px){
		.preFilterBlk .d-flex {flex-direction: column; margin-bottom: 10px;}
		.filter-tag-row {padding: 0 15px;}
	}

</style>

